import React, {useEffect, useState} from "react";
import axios from "axios";
import {ApiUrl} from "../../../../auth/authMethods";
import BasicLoader from "../../../../component/BasicLoader/BasicLoader";
import ErrorIcon from '@mui/icons-material/Error';
import LoadingButton from "@mui/lab/LoadingButton";
import CheckIcon from "@mui/icons-material/Check";
import DeleteIcon from '@mui/icons-material/Delete';

export default function SellerLogoDisplay({participante, setLoadData, logoVendedor}) {
    const [image, setImage] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);

    const [loadingRemove, setLoadingRemove] = useState(false);
    const [removed, setRemoved] = useState(false);

    const url = `${ApiUrl}/seller-logo/${participante.id}`

    useEffect(() => {
        // Função para buscar a imagem do backend
        const fetchFoto = async () => {
            try {
                // Request GET usando Axios
                const response = await axios.get(`${url}/image`);

                // Converte para data URL e salva no state
                setImage(`data:image/jpeg;base64,${response.data}`);
                setLoading(false);
            } catch (err) {
                console.error("Erro ao buscar a imagem:", err);
                setError(true);
                setLoading(false);
            }
        };

        fetchFoto();
    }, [participante]);


    const deleteImgae = async () => {
        setLoadingRemove(true)

        await axios.delete(url)
            .then((response) => {
                setRemoved(true);
            })
            .catch(e => {
                setError(true)
            })
            .finally(() => {
                setLoadingRemove(false)
            })
    }

    useEffect(() => {
        if (removed) {
            const timer = setTimeout(() => {
                setLoadData(true);
            }, 1 * 1000);

            return () => clearTimeout(timer);
        }
    }, [removed])

    if (loading) return <BasicLoader message={'Buscando foto...'} height={10}/>
    if (error && !image) return <h5 className={'text-danger m-2'}>
        <ErrorIcon/>Erro ao carregar a foto.
    </h5>

    return <>
        <div style={{textAlign: "center"}}>
            <p>Imagem salva: {logoVendedor?.fileName}</p>
            <img
                src={image}
                alt="Logo do participante"
                style={{maxWidth: "100%", maxHeight: "300px", objectFit: "contain"}}
            />

            <br/>

            {!removed ?
                <LoadingButton
                    onClick={deleteImgae}
                    loading={loadingRemove}
                    loadingPosition="start"
                    variant="contained"
                    color="error"
                    startIcon={<DeleteIcon/>}
                    className={'mt-2'}
                >
                    Excluir imagem
                </LoadingButton>
                :
                <p className={'text-success'}>
                    <CheckIcon/> Imagem removida com sucesso!
                </p>
            }
        </div>
    </>
}
